export default (selectedOption, selectField, textField, counter) => ({
    selectedOption,
    selectField,
    textField,
    counter,

    init(){
        this.checkArbitrary();
    },

    reset(value) {
        value = Number.isInteger(value);

        if (value) {
            if (this.textField) {
                this.textField = '';
            }

            this.selectedOption = 'select';
        }

        if (!value) {
            this.selectedOption = 'input';
        }
    },

    checkArbitrary() {
        if (this.counter === 0) {
            this.selectedOption = 'input';

            return;
        }

        if (this.selectedOption === 'input' && this.textField) {
            return;
        }

        this.selectedOption = 'select';
    }
})
